/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { default as ContentDescription } from "./ContentDescription";
export type { ContentDescriptionProps } from "./ContentDescriptionProps";
